<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-06-04 16:13:22
-->
<template>
	<div class="mt-16 yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="100px">
			<el-form-item label="商品名称">
				<el-input maxlength="70" v-model="formData['product_name']" placeholder="请输入商品名称" @change="e => change(e, '商品名称', 1)"></el-input>
			</el-form-item>
			<el-form-item label="商品ID">
				<el-input v-model="formData['third_product_id']" placeholder="请输入商品ID" @change="e => change(e, '商品ID', 2)"></el-input>
			</el-form-item>
			<el-form-item label="订单ID">
				<el-input v-model="formData['order_id']" placeholder="请输入订单ID" @change="e => change(e, '订单ID', 3)"></el-input>
			</el-form-item>
			<el-form-item label="订单状态">
				<el-select v-model="formData['order_status']" clearable placeholder="请选择订单状态" @change="e => change(e, '订单状态', 4)">
					<el-option :label="item.label" :value="item.value" v-for="(item, index) in orderState" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="drName" v-if="isAllDataView">
				<dr-partner-select
					ref="drPartnerSelect"
					:apiType="2"
					v-model="formData['talent_user_id']"
					:placeholder="`请选择${drName}`"
					:customData="customList"
					@change="drChange"
				></dr-partner-select>
			</el-form-item>
			<el-form-item :label="zsName" v-if="isAllDataView">
				<zs-partner-select
					ref="zsPartnerSelect"
					multiple
					:showIcon="false"
					:apiType="2"
					v-model="formData['bd_user_ids']"
					:placeholder="`请选择${zsName}`"
					:customData="customList"
					@change="zsChange"
				/>
			</el-form-item>
			<el-form-item label="授权团长">
				<commander-select :platformId="platformId" v-model="formData['authority_id']"></commander-select>
			</el-form-item>
			<el-form-item label="">
				<MultiDatePicker
					v-model="mulTime"
					ref="multiDatePicker"
					:list="timeList"
					:default-date="multiTimeDefaultDte"
					label-width="96"
					:custom="['_start', '_end']"
					@change="payTime"
					:clearable="false"
					:picker-options="pickerOptions"
				></MultiDatePicker>
			</el-form-item>
			<template>
				<el-form-item label="出单二级团" v-if="$isPlatOr(['Dy', 'Ks']) || ($isSp() && tabName === '0')">
					<el-input
						maxlength="70"
						clearable
						v-model="formData['sec_colonel_name']"
						placeholder="请输入团长昵称"
						@change="e => change(e, '团长昵称', 9)"
					></el-input>
				</el-form-item>
				<el-form-item label="达人昵称">
					<el-input
						maxlength="70"
						clearable
						v-model="formData['anchor_name']"
						placeholder="请输入达人昵称"
						@change="e => change(e, '达人昵称', 10)"
					></el-input>
				</el-form-item>
				<el-form-item label="达人快手ID" v-if="$isKs()">
					<el-input clearable v-model="formData['anchor_uid']" placeholder="请输入达人快手ID" @change="e => change(e, 'anchor_uid', 11)"></el-input>
				</el-form-item>
				<el-form-item label="达人视频号ID" v-else-if="$isSp()">
					<el-input
						clearable
						v-model="formData['anchorAccount']"
						placeholder="请输入达人视频号ID"
						@change="e => change(e, 'anchorAccount', 11)"
					></el-input>
				</el-form-item>
				<el-form-item label="达人抖音号" v-else>
					<el-input
						clearable
						v-model="formData['anchor_account']"
						placeholder="请输入达人抖音号"
						@change="e => change(e, '达人抖音号', 12)"
					></el-input>
				</el-form-item>
			</template>
			<el-form-item label="推广者类型" v-if="tabName === '0'">
				<el-select v-model="formData['colonel_type']" clearable filterable placeholder="请选择" @change="e => change(e, '推广者类型', 13)">
					<el-option :label="item.name" :value="item.id" v-for="(item, index) in extendArr" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="店铺">
				<el-input maxlength="70" clearable v-model="formData['shop_name']" placeholder="请输入" @change="e => change(e, '店铺', 15)"></el-input>
			</el-form-item>
			<el-form-item label="店铺ID">
				<el-input clearable v-model="formData['shop_id']" placeholder="请输入" @change="e => change(e, '店铺ID', 16)"></el-input>
			</el-form-item>
			<el-form-item v-if="$isDy() && tabName === '0'">
				<el-dropdown @command="activitySelected">
					<span
						class="el-dropdown-link yx-color-text-regular pr-12 text-align-right"
						style="width: 100px; display: inline-block; box-sizing: border-box"
					>
						<!-- label表示数组的第一个标签，当选择对应的label后赋值给selectedLabel来替代label的展示 -->
						{{ activityLabel }}
						<i class="el-icon-arrow-down"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="item in activityFieldList" :key="item.value" :command="item">{{ item.label }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-input clearable v-model="formData[activityKey]" placeholder="请输入" @change="e => change(e, activityLabel, 17)"></el-input>
			</el-form-item>
			<el-form-item label="活动ID" v-else-if="!$isSp()">
				<el-input clearable v-model="formData['activity_id']" placeholder="请输入" @change="e => change(e, '活动ID', 17)"></el-input>
			</el-form-item>
			<el-form-item label="部门" v-if="!isPersonDataScope && !$isSp()">
				<deptTreeSelect returnArray v-model="formData['dept_ids']" :collapseTags="true" size="small" ref="deptTreeSelect" />
			</el-form-item>
			<el-form-item label="带货类型" v-if="$isPlatOr(platformId, ['Dy', 'Ks'])">
				<el-select v-model="formData['media_type']" clearable placeholder="请选择带货类型" @change="e => change(e, '带货类型', 4)">
					<el-option :label="item.label" :value="item.value" v-for="(item, index) in mediaTypeArr" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label=" " v-if="$auth.hasPermi('system:Order-FilterAbnormalOrders')">
				<el-checkbox v-model="formData.attribution_status" true-label="abnormal" false-label="" @change="e => change(e, '异常订单', 14)">
					<div class="flex flex-align-center">
						<div class="mr-4">异常订单</div>
						<explain content="招商运营+达人商务的提成超过服务费收入" />
					</div>
				</el-checkbox>
			</el-form-item>
			<el-form-item label=" ">
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear()">清空</el-button>
				<template v-if="$auth.hasPermi('system:order:editOrder') && tabName === '0'">
					<affiliation-button @onSubmit="onSubmit" class="ml-12" mode="batch" :platformId="platformId"></affiliation-button>
				</template>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import throttle from 'lodash/throttle';
import DrPartnerSelect from '@/components/drPartnerSelect';
import zsPartnerSelect from '@/components/zsPartnerSelect';
import explain from '@/components/common/explain';
import AffiliationButton from './affiliationButton';
import { PLATFORM_KS, drRoleType, zsRoleType } from '@/utils/dataMap';
import { format, getUnixTime } from 'date-fns';
import { calDate, disabledDate } from '@/utils/common';
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect.vue';
import commanderSelect from '@/components/commanderSelect/index.vue';
import dataMap from '../../../../../utils/dataMap';

export default {
	name: 'search',
	computed: {
		...mapGetters(['showDeptSelect', 'isAllDataView', 'isDrPartnerDataView', 'isShopPartnerDataView', 'isPersonDataScope']),
		isKsPlatform() {
			return +this.platformId === +PLATFORM_KS.value;
		},
		orderState() {
			const dyOrderStatusList = [
				{
					label: '支付完成',
					value: 'PAY_SUCC',
				},
				{
					label: '退款',
					value: 'REFUND',
				},
				{
					label: '结算',
					value: 'SETTLE',
				},
				{
					label: '确认收货',
					value: 'CONFIRM',
				},
			];
			const ksOrderStatusList = [
				{
					label: '全部订单',
					value: '0',
				},
				{
					label: '已付款',
					value: '30',
				},
				{
					label: '已收货',
					value: '50',
				},
				{
					label: '已结算',
					value: '60',
				},
				{
					label: '已失效',
					value: '80',
				},
			];
			const orderStateMap = {
				[dataMap.PLATFORM_DY.value]: dyOrderStatusList,
				[dataMap.PLATFORM_KS.value]: ksOrderStatusList,
				[dataMap.PLATFORM_SP.value]: dyOrderStatusList,
			};
			return orderStateMap[this.platformId];
		},
		drName() {
			return drRoleType.name;
		},
		zsName() {
			return zsRoleType.name;
		},
		extendArr({ platformId }) {
			const obj = {
				1: [
					{ name: '全部', id: '' },
					{ name: '达人', id: '2' },
					{ name: '团长', id: '1' },
				],
				2: [
					{ name: '全部', id: '' },
					{ name: '团长', id: '2' },
					{ name: '达人', id: '1' },
				],
				3: [
					{ name: '团长', id: '2' },
					{ name: '达人', id: '1' },
				],
			};
			return obj[platformId];
		},
		mediaTypeArr() {
			const dyMediaTypeList = [
				{
					label: '全部',
					value: '',
				},
				{
					label: '橱窗',
					value: 'shop_list',
				},
				{
					label: this.$isKs(this.platformId) ? '短视频' : '视频',
					value: 'video',
				},
				{
					label: '直播',
					value: 'live',
				},
				{
					label: '其他',
					value: 'others',
				},
			];
			return dyMediaTypeList;
		},
	},
	components: {
		DrPartnerSelect,
		zsPartnerSelect,
		explain,
		AffiliationButton,
		commanderSelect,
		deptTreeSelect,
	},
	props: {
		tabName: {
			type: String,
			default: '0',
		},
		platformId: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			pickerOptions: {
				disabledDate: time => disabledDate(time, 179, true),
			},
			multiTimeDefaultDte: [],
			timeList: [
				{ label: '付款时间', value: 'pay_time' },
				{ label: '结算时间', value: 'settle_time' },
			],
			mulTime: {
				pay_time_start: '',
				pay_time_end: '',
			},
			formData: {
				order_status: '',
				authority_id: '',
				bd_user_ids: [],
				dept_ids: [],
			},
			oldBdUserIds: [],
			checked: false,
			customList: [{ userId: 0, name: '未归属' }],
			paramsTextObj: {},
			activityFieldList: [
				{ label: '一级活动ID', value: 'activity_id' },
				{ label: '二级活动ID', value: 'sec_activity_id' },
			],
			activityLabel: '一级活动ID',
			activityKey: 'activity_id',
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.payTimeSearch();
			const [todayStart, todayEnd] = calDate(0);
			this.multiTimeDefaultDte = [Date.parse(todayStart), Date.parse(todayEnd)];
			const { order_status } = this.$route.query;
			if (order_status) this.formData.order_status = order_status;
		},
		payTimeSearch() {
			const { from_time, to_time } = this.$route.query;

			// 默认值优先为链接中带的时间戳，其次取当天，清除时将时间置为空
			if (from_time && to_time) {
				// 有传递过来开始结束时间，时间类型
				const start = Number(from_time) * 1000;
				const end = Number(to_time) * 1000;
				this.mulTime = {
					pay_time_start: start,
					pay_time_end: end,
				};
			} else {
				const [todayStart, todayEnd] = calDate(0);
				// 未传递过来默认取昨日的开始结束时间
				const pay_time_start = Date.parse(todayStart);
				const pay_time_end = Date.parse(todayEnd);
				this.mulTime = {
					pay_time_start,
					pay_time_end,
				};
			}

			this.payTime(this.mulTime);
		},
		onClear() {
			this.formData = {
				order_status: '',
				authority_id: '',
				bd_user_ids: [],
				dept_ids: [],
			};
			this.$set(this.formData, 'attribution_status', '');
			this.payTimeSearch();
			this.activityLabel = '一级活动ID';
			this.activityKey = 'activity_id';
			this.$refs.multiDatePicker.reset();
			this.paramsTextObj = {};
			this.onSubmit();
		},
		payTime(value) {
			const keys = Object.keys(value);
			// 时间筛选为单选，所以需要清除原formDate和paramsTextObj中的时间筛选项
			this.clearTimeParams(this.timeList);
			// 设置当前表单中时间数据
			keys.forEach(item => {
				this.formData[item] = value[item] ? getUnixTime(value[item]) : '';
			});
			// 设置修改归属弹窗中展示的数据
			const targetTime = this.timeList.find(item => keys[0].includes(item.value));
			const [start, end] = Object.values(value);
			this.paramsTextObj[targetTime.label] = {
				text: start ? `${format(new Date(start), 'yyyy/MM/dd')}-${format(new Date(end), 'yyyy/MM/dd')}` : '',
				value: [start, end],
				order: 1,
			};
		},
		// 只能存在一个时间筛选，清除已存在的时间筛选
		clearTimeParams(list = []) {
			const paramsKeys = Object.keys(this.paramsTextObj);
			const formDateKeys = Object.keys(this.formData);
			list.forEach(time => {
				// 清除修改归属里原时间数据
				if (paramsKeys.includes(time.label)) {
					delete this.paramsTextObj[time.label];
				}
				// 清除表单筛选对象里原时间数据
				formDateKeys.forEach(formKey => {
					if (formKey.includes(time.value)) {
						delete this.formData[formKey];
					}
				});
			});
		},
		timestampToTime(timestamp) {
			let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
			let Y = date.getFullYear() + '-';
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
			let D = date.getDate() + ' ';
			return Y + M + D;
		},
		onSubmit: throttle(function () {
			const paramsTextArr = Object.keys(this.paramsTextObj)
				.map(key => ({ key, ...this.paramsTextObj[key] }))
				.filter(item => item.text !== '')
				.sort((prev, next) => prev.order - next.order);
			this.$emit('setParamsTextArr', paramsTextArr);
			this.$emit('onSubmit', this.formData);
		}, 1000),
		drChange(value) {
			this.formData.partner_claimed = value === 0 ? 1 : '';
			const text = this.$refs.drPartnerSelect.optionList.find(item => item.userId === value)?.name || '';
			this.paramsTextObj[this.drName] = { text, value, order: 5 };
		},
		zsChange(newVal) {
			let newindex = newVal.indexOf(0),
				oldindex = this.oldBdUserIds.indexOf(0); //获取val和oldval里未归属的索引,如果没有则返回-1
			if (newindex != -1 && oldindex == -1) {
				// 勾选未归属
				this.formData.bd_user_ids = [0];
				this.formData.bd_partner_claimed = 1;
			} else if (newindex != -1 && oldindex != -1) {
				this.formData.bd_user_ids.splice(newVal.indexOf(0), 1); // 再次勾选了未归属之外的
				this.formData.bd_partner_claimed = 0;
			} else if (newindex == -1) {
				// 取消未归属勾选
				this.formData.bd_partner_claimed = 0;
			}
			this.oldBdUserIds = newVal.slice(0);
			const text =
				this.$refs.zsPartnerSelect.optionList
					.filter(item => newVal.includes(item.userId))
					?.reduce((pre, cur) => pre + (pre ? '、' : '') + cur.name, '') || '';
			this.paramsTextObj[this.zsName] = { text, newVal, order: 6 };
		},
		activitySelected(e) {
			this.activityLabel = e.label;
			this.activityKey = e.value;
			this.clearTimeParams(this.activityFieldList);
		},
		change(e, key, order) {
			let text = e;
			if (key === '订单状态') {
				text = this.orderState.find(item => item.value === e)?.key || '';
			}
			if (key === '推广者类型') {
				text = this.extendArr.find(item => item.id === e)?.name || '';
			}
			if (key === '异常订单') {
				text = e ? '已选择异常订单' : '';
			}
			if (key === '带货类型') {
				text = this.mediaTypeArr.find(item => item.value === e)?.key || '';
			}
			this.paramsTextObj[key] = { text, value: e, order };
		},
	},
};
</script>
